import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const StyledDate = styled.div`
    display: flex;
    .date-container {
        display: flex;
        align-items: center;
        .line {
            width: 14px;
            margin-inline: 10px;
            height: 1px;
            background: black;
            border: 1px solid #262626;
        }
    }
    .react-datepicker__input-container {
        box-shadow: 0px 58px 23px rgba(201, 201, 201, 0.01), 0px 32px 19px rgba(201, 201, 201, 0.03), 0px 14px 14px rgba(201, 201, 201, 0.04),
            0px 4px 8px rgba(201, 201, 201, 0.05), 0px 0px 0px rgba(201, 201, 201, 0.05);
    }

    .react-datepicker-popper {
        z-index: 100;
    }

    .react-datepicker {
        border: none;
        box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
        padding: 10px;
        &__day {
            width: 44px;
            height: 26px;
            border-radius: 20px;
            border: 2px solid white;

            &:hover {
                width: 44px;
                height: 26px;
                border-radius: 20px;
                background: white;
                color: black;
                border: 2px solid #0d8ceb;
            }
        }

        &__day--today {
            text-decoration: underline;
        }
        button {
            background: rgba(13, 140, 235, 0.1);
            border-radius: 8px;
            transform: translateY(50%);
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 20px;
            width: 24px;
            height: 24px;
        }

        &__navigation-icon::before {
            width: 6px !important;
            height: 6px !important;
            top: 8px;
            right: -1px;
        }
        &__navigation-icon--next {
            left: 1.5px;
        }
        &__navigation-icon--previous {
            left: 5px;
        }
    }

    .react-datepicker__day--in-range {
        background: #0d8ceb;
        &:hover {
            background: #34aadc;
        }
    }
    .react-datepicker__day--selected {
        background: #0d8ceb;
        &:hover {
            background: #34aadc;
        }
    }
    .react-datepicker-wrapper {
        /* border: none; */
        input {
            outline: none;
            cursor: pointer;
            padding: 8px 15px;
            border: none;
            width: 140px;
            height: 46px;
            background: #ffffff;
            border-radius: 6px;
            &:focus {
                border: #0d8ceb !important;
            }
        }
    }
    .react-datepicker__current-month,
    .react-datepicker__triangle {
        display: none;
    }
    .react-datepicker__header {
        background: white;
        border: none;
    }
    .react-datepicker__year-dropdown,
    .react-datepicker__month-dropdown {
        background: white;
        padding: 20px 0;
        border: none;
        box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    }
    .react-datepicker__navigation--years-upcoming {
        display: none;
    }
`;

const DatePickerCalendar = ({ from, to, onChange }) => {
    const [startDate, setStartDate] = useState(moment().toDate());
    const [endDate, setEndDate] = useState(moment().toDate());

    const changeHandle = (date, isStart) => {
        if (isStart) {
            setStartDate(date);
            onChange({ fromDate: moment(date).valueOf(), toDate: moment(endDate).valueOf() });
        } else {
            setEndDate(date);
            onChange({ fromDate: moment(startDate).valueOf(), toDate: moment(date).valueOf() });
        }
    };

    useEffect(() => {
        if (from) setStartDate(moment(from).toDate());
        if (to) setEndDate(moment(to).toDate());
    }, [from, to]);

    return (
        <StyledDate>
            <div className="date-container">
                <DatePicker
                    selected={startDate}
                    onChange={(date) => changeHandle(date, true)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    shouldCloseOnSelect
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={20}
                    dateFormat="dd.MMM.yyyy"
                />
                <span className="line"></span>
                <DatePicker
                    selected={endDate}
                    onChange={(date) => changeHandle(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    shouldCloseOnSelect
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={20}
                    dateFormat="dd.MMM.yyyy"
                />
            </div>
        </StyledDate>
    );
};

export default DatePickerCalendar;
